module.exports = __webpack_public_path__ + "static/media/rectangle-7.ab646ee7.svg";